import { CSSProperties, PropsWithChildren, useMemo } from 'react'

import { FormGridContext } from './contexts'
import { useFormGridContext } from './hooks/useContext'
import { FormGridProps, GridColumnProps } from './interface'
import { resolveGridStyles } from './utils'

const InternalFormGrid = ({
  className,
  style: externalStyle,
  columns,
  columnGap = 8,
  rowGap,
  minWidth,
  maxWidth,
  children
}: PropsWithChildren<FormGridProps>) => {
  const style = useMemo(
    () => resolveGridStyles(columns, minWidth, maxWidth),
    [columns, minWidth, maxWidth]
  )

  return (
    <FormGridContext
      value={{
        columns,
        columnGap,
        rowGap,
        minWidth,
        maxWidth
      }}
    >
      <div
        className={className}
        style={{
          columnGap,
          rowGap,
          ...style,
          ...externalStyle
        }}
      >
        {children}
      </div>
    </FormGridContext>
  )
}

const GridColumn = ({
  gridSpan = 1,
  style: externalStyle,
  ...props
}: PropsWithChildren<GridColumnProps>) => {
  const { columns, minWidth, maxWidth } = useFormGridContext()

  const style: CSSProperties = {
    ...externalStyle,
    gridColumn: `span ${gridSpan}`
  }

  if (!columns) {
    style.minWidth = minWidth
    style.maxWidth = maxWidth
  }

  return <div {...props} data-grid-span={gridSpan} style={style} />
}

export const FormGrid = Object.assign(InternalFormGrid, {
  Column: GridColumn
})
